
const TWELVE_DATA_API_KEY = "19e3cbda066d4918b3d3c518cc145f4a";
const BASE_URL = "https://api.twelvedata.com";

export async function fetchStockData(symbol: string, interval: string = "1month", outputsize: number = 240) {
  try {
    const response = await fetch(
      `${BASE_URL}/time_series?symbol=${symbol}&interval=${interval}&outputsize=${outputsize}&apikey=${TWELVE_DATA_API_KEY}`
    );
    const data = await response.json();
    
    if (data.code === 429) {
      throw new Error("API rate limit exceeded. Please try again later.");
    }
    
    if (data.status === "error") {
      throw new Error(data.message || "Failed to fetch stock data");
    }
    
    if (!data.values || data.values.length === 0) {
      throw new Error("No data available for this stock symbol");
    }
    
    return data;
  } catch (error) {
    console.error("Error fetching stock data:", error);
    throw error;
  }
}

export async function getStockInfo(symbol: string) {
  try {
    const response = await fetch(
      `${BASE_URL}/quote?symbol=${symbol}&apikey=${TWELVE_DATA_API_KEY}`
    );
    const data = await response.json();
    
    if (data.code === 429) {
      throw new Error("API rate limit exceeded. Please try again later.");
    }
    
    if (data.status === "error") {
      throw new Error(data.message || "Failed to fetch stock information");
    }
    
    return data;
  } catch (error) {
    console.error("Error fetching stock info:", error);
    throw error;
  }
}

export async function searchStocks(query: string) {
  try {
    const response = await fetch(
      `${BASE_URL}/symbol_search?symbol=${query}&outputsize=30&apikey=${TWELVE_DATA_API_KEY}`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error searching stocks:", error);
    throw error;
  }
}
